import { cn } from '@/lib/utils'

interface ImageTextSplitProps {
  imageSrc: string
  imageAlt: string
  heading: string
  body: string
  imagePosition?: 'left' | 'right'
  variant?: 'light' | 'dark'
  className?: string
}

export function ImageTextSplit({
  imageSrc,
  imageAlt,
  heading,
  body,
  imagePosition = 'left',
  variant = 'light',
  className,
}: ImageTextSplitProps) {
  const isDark = variant === 'dark'
  return (
    <section
      className={cn(
        'py-20 md:py-28 border-t-4 border-brand-red',
        isDark ? 'bg-black' : 'bg-white',
        className,
      )}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div
          className={cn(
            'grid grid-cols-1 lg:grid-cols-2 gap-12 items-center',
            imagePosition === 'right' && 'lg:[direction:rtl]'
          )}
        >
          <div className={cn(imagePosition === 'right' && 'lg:[direction:ltr]')}>
            <img
              src={imageSrc}
              alt={imageAlt}
              className="w-full h-64 md:h-96 object-cover rounded-xl"
              loading="lazy"
            />
          </div>
          <div className={cn(imagePosition === 'right' && 'lg:[direction:ltr]')}>
            <h2
              className={cn(
                'text-2xl md:text-4xl font-bold mb-6',
                isDark ? 'text-white' : 'text-brand-dark',
              )}
            >
              {heading}
            </h2>
            <p
              className={cn(
                'text-lg leading-relaxed',
                isDark ? 'text-white/80' : 'text-brand-text',
              )}
            >
              {body}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
